import React from "react";

import {
TextField,
} from "@mui/material";

import { Controller } from "react-hook-form";
import { commonErrorParameters } from "./fields";
import { withStyles } from "@mui/styles";

const ITEM_HEIGHT = 48;

interface ZPlayMultipleSelectProps extends Readonly<{ children?: React.ReactNode }>
{
name: string,
label: string,
control: any,
trigger: any,
formState: any,
disabled?: boolean,
required?: boolean,
defaultValue?: any,
onChange?: (data: string[]) => string[],
}

const styles = () => ({
	root: {
		"& .MuiInputBase-formControl .MuiNativeSelect-select-MuiInputBase-input-MuiFilledInput-input": {
			backgroundColor: "#FFFFFF",
		}
	}
});

class ZPlayMultipleSelect extends React.Component<ZPlayMultipleSelectProps, {}>
{
  static defaultProps = {
		disabled: false,
		required: false,
		variant: "standard",
	};

render()
{
	return (<Controller
			name={this.props.name}
			control={this.props.control}
			defaultValue={this.props.defaultValue || ""}
			render={({field}) => (<TextField
					{...field}
					select
					fullWidth
					required={this.props.required}
					disabled={this.props.disabled || this.props.formState.isSubmitting}
					label={this.props.label}
					variant="filled"
					size="small"
					{...commonErrorParameters(this.props.name, this.props.formState)}
					SelectProps={{
						MenuProps: {PaperProps: {sx: {maxHeight: ITEM_HEIGHT * 4.5}}},
						multiple: true,
					}}
					onChange={({target: {value}}) => {
						const newValue = [value];
						const finalValue = this.props.onChange?.(newValue) || newValue;
						field.onChange(finalValue);
						this.props.trigger(this.props.name);
					}}
				>
					{this.props.children}
				</TextField>)}
		/>);
}
}

export default withStyles(styles)(ZPlayMultipleSelect);